import { useMemo } from 'react';

import { permissions, strings } from 'common';
import { testIds } from 'common/testIds';
import Button from 'components/shared/Button';
import PermissionsGate from 'components/shared/PermissionsGate';
import { Task, TaskStatus } from 'models';

interface DenyButtonProps {
  selectedIds: string[];
  tasks: Task[];
  loading: boolean;
  onClick: (status: TaskStatus) => void;
}

const DenyButton: React.FC<DenyButtonProps> = (props) => {
  const { selectedIds, tasks, loading, onClick } = props;

  const disabled = useMemo(() => {
    if (!selectedIds.length) {
      return true;
    }
    return !selectedIds.every((id) => {
      const task = tasks.find((task) => task.id === id);
      return (
        task?.status === 'DRAFT' ||
        task?.status === 'PENDING_APPROVAL' ||
        task?.status === 'APPROVED_PENDING_COMPLETE'
      );
    });
  }, [selectedIds, tasks]);

  return (
    <PermissionsGate permissions={[permissions.INVENTORY_VDP_TASKS_APPROVE]}>
      <Button
        data-vas-testing={testIds.REQUESTS_SECTION_DENY_BUTTON}
        className="FlatTasks-action-button FlatTasks-action-button-deny"
        id="deny-task-button"
        type="button"
        variant="danger"
        onClick={() => onClick('DENIED')}
        disabled={disabled}
        loading={loading}
      >
        {strings.DENY}
      </Button>
    </PermissionsGate>
  );
};

export default DenyButton;
